import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import axios from 'axios';

import { processTransactionDetails } from '../helpers/helpers';

import { API_URL, API_V4_URL } from '../config';

const REQUIRED_FIELDS = ['posId', 'storeName', 'transactionDate', 'orderId', 'cashierName', 'totalAmount'];

const processTransaction = async (id, history) => {
  if (!id) {
    throw new Error('Missing transaction ID');
  }
  
  const { data: { transactionDetails } } = await axios.get(
    `${API_URL}v2/api/pos/transaction/${id}`
  );
  
  history.replace(`/${transactionDetails.locationId}`, { transactionDetails });
};

const processMMITransaction = async (search, history) => {
  const urlParams = new URLSearchParams(search);
  const code = urlParams.get('code');
  
  if (!code) {
    throw new Error('Missing transaction details');
  }
  
  const transactionDetails = processTransactionDetails(code);
  
  if (transactionDetails.length < REQUIRED_FIELDS.length) {
    throw new Error('Transaction details is not complete');
  }
  
  const [posId] = transactionDetails;
  
  const { data } = await axios.get(
    `${API_V4_URL}api/v4/locations/pos/${posId}`
  );
  
  history.replace(`/${data.locationId}?code=${code}`);
};

const determineProcessingType = (id, search) => {
  if (id) {
    return 'pos';
  }
  
  const urlParams = new URLSearchParams(search);
  
  if (urlParams.get('code')) {
    return 'mmi-elr';
  }
  
  return null;
};

const useTransaction = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  
  useEffect(() => {
    const process = async () => {
      setLoading(true);
      setError(false);
      
      try {
        const processingType = determineProcessingType(params?.id, location.search);
        
        switch (processingType) {
          case 'pos':
            await processTransaction(params?.id, history);
            break;
          case 'mmi-elr':
            await processMMITransaction(location.search, history);
            break;
          default:
            throw new Error('Invalid pos type');
        }
      } catch (err) {
        console.log('Received error:', err);
        
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    
    process();
  }, [location.search, params.id, history]);
  
  return { loading, error };
};

export default useTransaction;
